import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { matchHelpRoute, usePageHelpIndex } from './usePageHelp';

// Map routes to page titles
const routeTitles: Record<string, string> = {
  '/manage/dashboard': 'Admin Dashboard',
  '/manage/scorecard': 'Executive Scorecard',
  '/dashboard': 'Dashboard',
  '/inbox': 'Inbox',
  '/operations/jobs': 'Jobs',
  '/operations/tasks': 'Tasks',
  '/operations/measurements': 'Measurements',
  '/operations/scheduling': 'Scheduling',
  '/operations/billing': 'Billing',
  '/operations/distributors': 'Distributors',
  '/crm': 'CRM',
  '/crm/contacts': 'Contacts',
  '/crm/pipeline': 'Sales Pipeline',
  '/crm/opportunities': 'Opportunities',
  '/crm/contracts': 'Contracts',
  '/crm/contract-templates': 'Contract Templates',
  '/crm/settings': 'CRM Settings',
  '/marketing': 'Marketing',
  '/marketing/local-seo': 'Local SEO',
  '/marketing/social-media': 'Social Media',
  '/marketing/content': 'Content Hub',
  '/marketing/media-library': 'Media Library',
  '/marketing/settings': 'Marketing Settings',
  '/cms': 'CMS',
  '/hawkeye': 'Hawkeye',
  '/hawkeye/dashboard': 'Hawkeye Dashboard',
  '/hawkeye/submit': 'Submit Analysis',
  '/hawkeye/history': 'Analysis History',
  '/policy-copilot': 'Policy Copilot',
  '/notifications': 'Notifications',
  '/settings': 'Settings',
  '/settings/users': 'Users',
  '/settings/profile': 'Profile',
  '/settings/organization': 'Organization',
  '/settings/billing': 'Billing Settings',
  '/advanced/automations': 'Automations',
  '/pages': 'Wiki',
};

/**
 * Hook to dynamically update the page title based on the current route
 */
export const usePageTitle = () => {
  const location = useLocation();
  const { data: helpIndex } = usePageHelpIndex();

  useEffect(() => {
    // Get the current path
    const path = location.pathname;

    // Try to find exact match first
    const helpRoute = matchHelpRoute(path, helpIndex);
    let title = helpIndex?.find(entry => entry.route === helpRoute)?.title || routeTitles[path];

    // If no exact match, try to find the best partial match
    if (!title) {
      const pathSegments = path.split('/').filter(Boolean);

      // Build paths from most specific to least specific
      for (let i = pathSegments.length; i > 0; i--) {
        const testPath = '/' + pathSegments.slice(0, i).join('/');
        if (routeTitles[testPath]) {
          title = routeTitles[testPath];
          break;
        }
      }
    }

    // Set the document title
    if (title) {
      document.title = `${title} - ApexOS`;
    } else {
      document.title = 'ApexOS';
    }
  }, [location.pathname, helpIndex]);
};
